import { useCallback, useEffect, useState } from 'react'
import IssueStatusesService from '../../../services/api/IssueStatusesService'

const useIssueStatuses = (collectId, params = {}) => {
  const { search, sort, direction } = params
  const [statuses, setStatuses] = useState([])
  const [loading, setLoading] = useState(true)
  const [hasLoaded, setHasLoaded] = useState(false)
  const [error, setError] = useState(null)
  const [refetchToken, setRefetchToken] = useState(0)

  const refetch = useCallback(() => setRefetchToken(token => token + 1), [])

  useEffect(() => {
    let cancelled = false

    if (collectId) {
      setLoading(true)
      setError(null)
      IssueStatusesService.fetchAll(collectId, { search, sort, direction }).then(response => {
        if (!cancelled)
          setStatuses(response.issue_statuses || [])
      }).catch(err => {
        if (cancelled)
          return
        setError(err)
        setStatuses([])
      }).finally(() => {
        if (cancelled)
          return
        setLoading(false)
        setHasLoaded(true)
      })
    }

    return () => { cancelled = true }
  }, [collectId, search, sort, direction, refetchToken])

  return { statuses, loading, hasLoaded, error, refetch }
}

export default useIssueStatuses
